export default __webpack_public_path__ + "8cc1eef.png";